import { Spinner, Message } from '../../components'
import {
  inputCheckBox,
  inputEmailDisabled,
  inputTextDisabled,
} from '../../utils/dynamicForm'

const FormUsers = ({
  edit,
  formCleanHandler,
  isLoading,
  register,
  isError,
  errors,
  watch,
  isLoadingUpdate,
  isLoadingPost,
  handleSubmit,
  submitHandler,
  error,
}) => {
  return (
    <div
      className='modal fade'
      id='userModal'
      data-bs-backdrop='static'
      data-bs-keyboard='false'
      tabIndex='-1'
      aria-labelledby='userModalLabel'
    >
      <div className='modal-dialog'>
        <div className='modal-content modal-background'>
          <div className='modal-header'>
            <h3 className='modal-title ' id='userModalLabel'>
              {edit ? 'Editar Usuario' : 'Crear Usuario'}
            </h3>
            <button
              type='button'
              className='btn-close'
              data-bs-dismiss='modal'
              aria-label='Close'
              onClick={formCleanHandler}
            ></button>
          </div>
          <div className='modal-body'>
            {isLoading ? (
              <Spinner />
            ) : isError ? (
              <Message variant='danger'>{error}</Message>
            ) : (
              <form onSubmit={handleSubmit(submitHandler)}>
                {inputTextDisabled({
                  register,
                  errors,
                  label: 'Nombres',
                  name: 'name',
                  placeholder: 'Nombres',
                
                })}
                {inputTextDisabled({
                  register,
                  errors,
                  label: 'Apellidos',
                  name: 'lastname',
                  placeholder: 'Apellidos',

                })}
                {inputEmailDisabled({
                  register,
                  errors,
                  label: 'Correo Electrónico',
                  name: 'email',
                  placeholder: 'Correo Electrónico',
                
                })}

                {inputCheckBox({
                  register,
                  errors,
                  watch,
                  name: 'blocked',
                  label: 'Bloqueado',
                  isRequired: false,
                  placeholder: 'Bloqueado',
                })}
                <div className='row text-center'>

                  <div className="col-md-4">

                  </div>

                  <div className="col-md-4">
                    <button
                      type='submit'
                      className='btn btn-primary '
                      disabled={isLoadingPost || isLoadingUpdate}
                    >
                      {isLoadingPost || isLoadingUpdate ? (
                        <span className='spinner-border spinner-border-sm' />
                      ) : (
                        'Actualizar'
                      )}
                    </button>
                  </div>

                  <div className="col-md-4">

                  </div>

                </div>
              </form>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default FormUsers
